import React, { Component } from "react";
import { Layout, Menu, Dropdown, Button, Avatar, Image } from "antd";
import { UserOutlined, CarOutlined, LogoutOutlined, ProfileOutlined, ShoppingOutlined, ShopOutlined, TableOutlined, FundViewOutlined, FileExcelOutlined } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { notification } from "antd";
import "./MenuLayout.css";
import { connect } from "react-redux";
import { logout_profile, load_profile } from "../redux/actions/profile";
import { clear_route_id } from "../redux/actions/route";
import { clear_customer_id } from "../redux/actions/customer";
import { setCurrentBranch } from "../services/api";
import w_logo from "../assets/warithep_logo.jpeg";
import { prepend } from "../utils";

const { Sider, Content, Footer } = Layout;

const notiMethods = ["post", "put", "delete"];

const menuNameMap = {
  users: "ผู้ใช้",
  products: "สินค้า",
  branches: "สาขา",
  routes: "รายการสาย",
  profile: "ข้อมูลผู้ใช้",
};
class MenuLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMenu: "",
      openedMenu: "",
      menuCollapsed: false
    };
    this.onMenuClicked = this.onMenuClicked.bind(this);
    this.onLogoutClicked = this.onLogoutClicked.bind(this);
    this.getMenuItem = this.getMenuItem.bind(this);
    this.selectCurrentBranch = this.selectCurrentBranch.bind(this);
    this.onMenuCollapsed = this.onMenuCollapsed.bind(this);
  }

  onMenuClicked(menuName) {
    this.setState({
      selectedMenu: menuName["key"],
    });
    if (menuName["key"] === "logout") {
      this.onLogoutClicked();
      return;
    }
    const { history } = this.props;
    history.push(`/${menuName["key"]}`);
  }

  async selectCurrentBranch(id) {
    const { history, dispatch } = this.props;
    await setCurrentBranch(id);
    // Get new profile
    await dispatch(load_profile());
    history.push("/routes");
    window.location.reload(false);
  }

  async onLogoutClicked() {
    const { history, dispatch } = this.props;
    await dispatch(clear_customer_id());
    await dispatch(clear_route_id());
    dispatch(logout_profile());
    history.push(`/login`);
  }

  async componentWillMount() {
    const { history } = this.props;

    axios.interceptors.request.use(
      function (config) {
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        if (
          response.status === 200 &&
          notiMethods.includes(response.config.method) &&
          response.config.showSuccessMessage !== false
        ) {
          notification.destroy();
          notification["success"]({
            message: "เรียบร้อย!",
            description:
              response.config.successMessage || "ทำรายการสำเร็จลุล่วง",
          });
        }
        return response;
      },
      function (error) {
        if (error.response.status === 403) {
          history.push("/login");
        } else if (error.response.status === 401) {
          history.push("/page_not_found");
        } else {
          notification.destroy();
          notification["error"]({
            message: `เกิดข้อผิดพลาด (${error.response.status})`,
            description: error.response.data.error,
          });
        }

        return Promise.reject(error); // dont' throw here!!! each function need to handle 500 individually
      }
    );
    // Preselect menu
    const urlArr = window.location.href.split("/");
    const selectedMenu = urlArr[urlArr.length - 1];
    let openedMenu;
    if (["users", "products", "branches"].includes(selectedMenu)) {
      openedMenu = "master_data";
    } else if (["profile"].includes(selectedMenu)) {
      openedMenu = "user_profile";
    }
    this.setState({
      openedMenu,
      selectedMenu,
    });
    // console.log(urlArr[urlArr.length - 1])
  }
  getMenuItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  onMenuCollapsed(collapsed, type){
    this.setState({
      menuCollapsed: collapsed
    })
  }

  render() {
    const { displayComponent, profile } = this.props;
    const { selectedMenu, openedMenu, menuCollapsed } = this.state;
    let items = [
      this.getMenuItem("รายการสาย", "routes", <CarOutlined />),
      this.getMenuItem("ดูแผนที่", "map_view", <FundViewOutlined />),
      this.getMenuItem("เอ็กซ์เซล", "excel_data", <FileExcelOutlined />),
      this.getMenuItem(
        <span>
          {profile.profile.first_name} {profile.profile.last_name}{" "}
        </span>,
        "user_profile",
        <UserOutlined />,
        [
          this.getMenuItem("ข้อมูลผู้ใช้", "profile", <ProfileOutlined />),
          this.getMenuItem("ออกจากระบบ", "logout", <LogoutOutlined />),
        ]
      )
    ]
    if (profile.profile.role === "ADMIN"){
      items = [this.getMenuItem("ข้อมูลหลัก", "master_data", <TableOutlined />, [
        this.getMenuItem("ผู้ใช้", "users", <UserOutlined />),
        this.getMenuItem("สินค้า", "products", <ShoppingOutlined />),
        this.getMenuItem("สาขา", "branches", <ShopOutlined />),
      ]),
      ...items]
    }
    return (
      <Layout>
        <Sider breakpoint="lg" 
          collapsible={true}
          defaultCollapsed={false}
          collapsedWidth="50"
          width={250}
          onCollapse={this.onMenuCollapsed}
        >
          {menuCollapsed ? <>
            <div className="logo-container">
              <Image src={w_logo} width={50} preview={false} />{" "}
            </div>
            <div className="logo-container">
              <span style={{fontSize: 14}}>
                {" "}
                {profile.profile.current_branch ? profile.profile.current_branch.code : ""}{" "}
                {/* {profile.profile.current_branch ? profile.profile.current_branch.name : ""}{" "} */}
              </span>
            </div>
          </> : 
            <div className="logo-container">
              <Image src={w_logo} width={50} preview={false} />{" "}
                {" "}
                {profile.profile.current_branch ? profile.profile.current_branch.code : ""}{" "}
                {profile.profile.current_branch ? profile.profile.current_branch.name : ""}{" "}
            </div>
          }
          <Menu
            defaultSelectedKeys={[selectedMenu]}
            defaultOpenKeys={[openedMenu]}
            mode="inline"
            theme="dark"
            items={items}
            inlineCollapsed={menuCollapsed}
            onClick={this.onMenuClicked}
          />
        </Sider>

        <Layout style={{ minHeight: "100vh" }}>
          <Content
            className="site-layout"
            style={{ padding: "0 50px", marginTop: 64 }}
          >
            <div
              style={{
                fontSize: 24,
                fontWeight: 800,
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              {menuNameMap[selectedMenu]}{" "}
            </div>
            <div
              className="site-layout-background page-container"
              style={{ padding: 24, height: "100%" }}
            >
              {displayComponent}
            </div>
          </Content>
          <Footer style={{ textAlign: "center" }}>
            v1.2.0 สนับสนุนโดย W035 วารีเทพอู่ทอง 
          </Footer>
        </Layout>
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: state.profile,
    routeId: state.route.routeId,
    customerId: state.customer.customerId,
    customerFormMode: state.customer.mode,
  };
}

export default withRouter(connect(mapStateToProps)(MenuLayout));
